"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageObject = void 0;
const models_1 = require("lincd/lib/models");
const package_1 = require("../package");
const schema_1 = require("../ontologies/schema");
const Server_1 = require("lincd-server-utils/lib/utils/Server");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const MediaObject_1 = require("./MediaObject");
const xsd_1 = require("lincd-xsd/lib/ontologies/xsd");
let ImageObject = class ImageObject extends MediaObject_1.MediaObject {
    get identifier() {
        return parseInt(this.getValue(schema_1.schema.identifier));
    }
    set identifier(val) {
        this.overwrite(schema_1.schema.identifier, new models_1.Literal(val.toString(), xsd_1.xsd.integer));
    }
    get name() {
        return this.getValue(schema_1.schema.name);
    }
    set name(val) {
        this.overwrite(schema_1.schema.name, new models_1.Literal(val));
    }
    static getAllFilestoreImages() {
        return Server_1.Server.call(this, 'getAllFilestoreImages');
    }
    static fromDataURL(dataURL, filePath, metaData) {
        return Server_1.Server.call(this, 'fromDataURL', dataURL, filePath, metaData);
    }
    static readImageFromDB(brandName) {
        return Server_1.Server.call(this, 'readImageFromDB', brandName);
    }
    /**
     * @param file
     * @param name optionally specify a name for the file
     */
    static fromFormFile(file, name) {
        var formData = new FormData();
        formData.append('upload', file, name || file.name);
        return Server_1.Server.callCustomShapeMethod(this, 'POST', 'fromFormFile', formData, {
            Accept: 'application/json, text/plain, */*',
            //content-type needs to specifically be left UNDEFINED
            //https://stackoverflow.com/questions/39280438/fetch-missing-boundary-in-multipart-form-data-post
        });
    }
};
ImageObject.targetClass = schema_1.schema.ImageObject;
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.identifier,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], ImageObject.prototype, "identifier", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.name,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], ImageObject.prototype, "name", null);
ImageObject = __decorate([
    package_1.linkedShape
], ImageObject);
exports.ImageObject = ImageObject;
//# sourceMappingURL=ImageObject.js.map